
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      function debounce(func, wait, immediate) {
  var timeout;
  return function executedFunction() {
    var context = this;
    var args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
export default {
  data: function () {
    return {
      data: {
        email: '',
        soothers: {
          spiritual: [],
          physical: [],
          emotional: [],
          social: []
        },
        settings: {
          programStartDate: '2019-01-01',
          maintenanceMode: false,
          defaultSoothersSeeded: false
        }
      }
    };
  },
  methods: {
    showToast: function (text) {
      if (!this.sootherToast) {
        this.sootherToast = this.$app.toast.create({
          closeTimeout: 2500,
          text: text
        });
      }
      this.sootherToast.params.text = text;
      this.sootherToast.open();
    },
    sootherExists: function (type, value) {
      let self = this;
      let list = self.soothers[type] || [];
      let target = value.toLowerCase();
      return list.some(item => item.value && item.value.toLowerCase() === target);
    },
    persistSoother: function (type, value) {
      let self = this;
      if (!self.data.soothers[type]) {
        self.data.soothers[type] = [];
      }
      let soother = {
        userId: self.$app.data.user.uid,
        value: value,
        type: type,
        order: self.data.soothers[type].length
      };
      return db.collection('soothers').add(soother).then(function (docRef) {
        soother.uid = docRef.id;
        self.data.soothers[type].push(soother);
        self.$setState(self.data);
        self.$app.data.hasSoothers = true;
        if (self.$app.emit) {
          self.$app.emit('soothers-updated', self.data.soothers);
        }
        return soother;
      }).catch(function (error) {
        console.error('Error adding document: ', error);
        self.showToast('We could not save that soother. Please try again.');
        throw error;
      });
    },
    addSoother: function (type) {
      let self = this;
      let $input = $$(`#add-${type}`);
      let val = ($input[0].value || '').trim();
      if (!val) {
        self.showToast('Enter a soother before adding.');
        return;
      }
      if (self.sootherExists(type, val)) {
        self.showToast('That soother is already on your list.');
        return;
      }
      self.persistSoother(type, val).then(function () {
        $input[0].value = '';
      }).catch(function () {
        // keep the value so the user can try again
      });
    },
    updateStartDate: debounce(function () {
      let self = this;
      let newDate = moment($$('#program-start-date')[0].value, 'YYYY-MM-DD', true);
      if (newDate.isValid()) {
        let settings = self.data.settings;
        settings.programStartDate = newDate.format('YYYY-MM-DD');
        self.updateSettings(settings);
      }
    }, 250),
    updateSettings: function (settings) {
      let self = this;
      db.collection('settings').doc(self.$app.data.user.uid).set(settings, {
        merge: true
      }).then().catch(err => {
        console.error('Error saving settings', err);
      });
      self.data.settings = settings;
      self.$setState(self.data);
      self.$app.data.settings = self.data.settings;
    },
    signOut: function () {
      firebase.auth().signOut();
      ui.start('#firebaseui-auth-container', uiConfig);
    },
    deleteAccount: function () {
      let self = this;
      let dialog = self.$app.dialog.confirm('This will permanently delete your account and all your data including entries, soothers, and settings. This action cannot be undone.', 'Delete Account?', function () {
        // User confirmed, show loading
        self.$app.preloader.show();
        let userId = self.$app.data.user.uid;

        // Delete all user data from Firestore
        let deletePromises = [];

        // Delete entries
        deletePromises.push(db.collection('entries').where('userId', '==', userId).get().then(function (querySnapshot) {
          let batch = db.batch();
          querySnapshot.forEach(function (doc) {
            batch.delete(doc.ref);
          });
          return batch.commit();
        }));

        // Delete soothers
        deletePromises.push(db.collection('soothers').where('userId', '==', userId).get().then(function (querySnapshot) {
          let batch = db.batch();
          querySnapshot.forEach(function (doc) {
            batch.delete(doc.ref);
          });
          return batch.commit();
        }));

        // Delete settings
        deletePromises.push(db.collection('settings').doc(userId).delete());

        // Wait for all Firestore deletions to complete
        Promise.all(deletePromises).then(function () {
          // All Firestore data deleted, now delete the auth account
          let user = firebase.auth().currentUser;
          return user.delete();
        }).then(function () {
          // Account deleted successfully
          self.$app.preloader.hide();
          // Firebase will automatically sign out the user and trigger the auth state listener
          // which will show the login screen
        }).catch(function (error) {
          self.$app.preloader.hide();
          console.error('Error deleting account:', error);

          // Check if re-authentication is required
          if (error.code === 'auth/requires-recent-login') {
            self.$app.dialog.alert('For security reasons, you need to sign out and sign back in before deleting your account.', 'Re-authentication Required');
          } else {
            self.$app.dialog.alert('An error occurred while deleting your account. Please try again or contact support.', 'Error');
          }
        });
      });
    }
  },
  on: {
    pageInit: function (e, page) {
      let self = this;
      self.data.soothers = {
        spiritual: [],
        physical: [],
        emotional: [],
        social: []
      };
      self.$app.on('logged-in', function () {
        db.collection('settings').doc(self.$app.data.user.uid).get().then(doc => {
          if (doc.exists) {
            self.data.settings = doc.data();
            if (typeof self.data.settings.defaultSoothersSeeded === 'undefined') {
              self.data.settings.defaultSoothersSeeded = false;
            }
          } else {
            let defaultData = {
              programStartDate: moment().format('YYYY-MM-DD'),
              maintenanceMode: false,
              defaultSoothersSeeded: true
            };
            self.data.settings = defaultData;
            db.collection('settings').doc(self.$app.data.user.uid).set(defaultData).then().catch(err => {
              console.error('Error setting default data in setting doc', err);
            });
          }
          self.$setState(self.data);
          self.$app.data.settings = self.data.settings;
        }).catch(err => {
          console.error('Error getting settings doc', err);
        });
        db.collection('soothers').where('userId', '==', self.$app.data.user.uid).orderBy('order').get().then(function (querySnapshot) {
          self.data.soothers = {
            spiritual: [],
            physical: [],
            emotional: [],
            social: []
          };
          let total = 0;
          querySnapshot.forEach(function (doc) {
            let soother = doc.data();
            soother.uid = doc.id;
            self.data.soothers[soother.type].push(soother);
            total += 1;
          });
          self.data.email = self.$app.data.user.email;
          self.$setState(self.data);
          self.$app.data.hasSoothers = total > 0;
          if (self.$app.events && self.$app.events.emit) {
            self.$app.events.emit('soothers-updated', self.data.soothers);
          }
        });
      });
      page.app.sortable.enable('.sortable');
      page.app.on('sortableSort', (listEl, indexes) => {
        let $parent = $$(listEl).parent();
        let type = $parent.data('type');
        $parent.find('li').forEach((el, idx) => {
          let uid = $$(el).data('uid');
          db.collection('soothers').doc(uid).update({
            order: idx
          });
        });
      });
      page.app.on('swipeoutDeleted', swipeoutEl => {
        let $item = $$(swipeoutEl);
        let uid = $item.data('uid');
        let type = $item.parents('ul').data('type');
        db.collection('soothers').doc(uid).delete().then(function () {
          if (type && self.data.soothers[type]) {
            self.data.soothers[type] = self.data.soothers[type].filter(item => item.uid !== uid);
          } else {
            Object.keys(self.data.soothers).forEach(key => {
              self.data.soothers[key] = self.data.soothers[key].filter(item => item.uid !== uid);
            });
          }
          self.$setState(self.data);
          let remaining = Object.keys(self.data.soothers).reduce((sum, key) => {
            return sum + self.data.soothers[key].length;
          }, 0);
          self.$app.data.hasSoothers = remaining > 0;
          if (self.$app.events && self.$app.events.emit) {
            self.$app.events.emit('soothers-updated', self.data.soothers);
          }
        }).catch(function (error) {
          console.error('Error removing document: ', error);
        });
      });
    }
  },
  id: '3c99237e96',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=title>Settings</div></div></div><div class=page-content><div class=block-title>Account</div><div class="list no-hairlines-md"><ul><li><div class="item-content item-input"><div class=item-inner><a href=# class=sign-out @click=signOut()>Sign Out</a></div></div></li><li><div class="item-content item-input"><div class=item-inner><a href=/welcome/ class=view-welcome-link>How to Use This App</a></div></div></li><li><div class="item-content item-input"><div class=item-inner><a href=# class=delete-account @click=deleteAccount()>Delete Account</a></div></div></li><li><div class="item-content item-input"><div class=item-inner><div class="item-title item-label">E-mail</div><div class=item-input-wrap><input type=email placeholder=E-mail value="';
      r += c(ctx_1.data.email, ctx_1);
      r += '" disabled=disabled></div></div></div></li><li><div class="item-content item-input"><div class=item-inner><div class="item-title item-label">Program Start Date</div><div class=item-input-wrap><input type=date placeholder="Program Start Date" value="';
      r += c(ctx_1.data.settings.programStartDate, ctx_1);
      r += '" id=program-start-date @change=updateStartDate()></div></div></div></li><li><div class=item-content><div class=item-inner><div class=item-title>Maintenance Mode</div><div class=item-after><label class="toggle toggle-init"><input type=checkbox> <span class=toggle-icon></span></label></div></div></div></li></ul></div><div class=block-title><strong>Soothers</strong></div><div class="block block-strong soother-intro"><p>Soothers are short, grounding activities that help you reconnect spiritually, physically, emotionally, and socially. They appear inside your daily journal entry so you can record what you actually practiced each day.</p><p>We start new accounts with a handful of common practices in each category. Refine the lists below to match your routines—add new ideas that fit you and remove anything that does not.</p></div><div class=block-title>Spiritual</div><div class="list inset sortable"><ul data-type=spiritual>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.soothers.spiritual, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li class=swipeout data-uid="';
          r += c(ctx_2.uid, ctx_2);
          r += '"><div class=swipeout-content><div class=item-content><div class=item-inner><div class=item-title>';
          r += c(ctx_2.value, ctx_2);
          r += '</div></div></div></div><div class=sortable-handler></div><div class=swipeout-actions-right><a href=# class=swipeout-delete>Delete</a></div></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div><div class="list inset add-soother"><ul><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><input type=text placeholder="Add Soother" id=add-spiritual> <span class=input-clear-button></span></div></div><div class=item-after><button class="col button button-fill button-round color-blue btn-add" @click="addSoother(\'spiritual\')">+Add</button></div></li></ul></div><div class=block-title>Physical</div><div class="list inset sortable"><ul data-type=physical>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.soothers.physical, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li class=swipeout data-uid="';
          r += c(ctx_2.uid, ctx_2);
          r += '"><div class=swipeout-content><div class=item-content><div class=item-inner><div class=item-title>';
          r += c(ctx_2.value, ctx_2);
          r += '</div></div></div></div><div class=sortable-handler></div><div class=swipeout-actions-right><a href=# class=swipeout-delete>Delete</a></div></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div><div class="list inset add-soother"><ul><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><input type=text placeholder="Add Soother" id=add-physical> <span class=input-clear-button></span></div></div><div class=item-after><button class="col button button-fill button-round color-blue btn-add" @click="addSoother(\'physical\')">+Add</button></div></li></ul></div><div class=block-title>Emotional</div><div class="list inset sortable"><ul data-type=emotional>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.soothers.emotional, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li class=swipeout data-uid="';
          r += c(ctx_2.uid, ctx_2);
          r += '"><div class=swipeout-content><div class=item-content><div class=item-inner><div class=item-title>';
          r += c(ctx_2.value, ctx_2);
          r += '</div></div></div></div><div class=sortable-handler></div><div class=swipeout-actions-right><a href=# class=swipeout-delete>Delete</a></div></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div><div class="list inset add-soother"><ul><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><input type=text placeholder="Add Soother" id=add-emotional> <span class=input-clear-button></span></div></div><div class=item-after><button class="col button button-fill button-round color-blue btn-add" @click="addSoother(\'emotional\')">+Add</button></div></li></ul></div><div class=block-title>Social</div><div class="list inset sortable"><ul data-type=social>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.data.soothers.social, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li class=swipeout data-uid="';
          r += c(ctx_2.uid, ctx_2);
          r += '"><div class=swipeout-content><div class=item-content><div class=item-inner><div class=item-title>';
          r += c(ctx_2.value, ctx_2);
          r += '</div></div></div></div><div class=sortable-handler></div><div class=swipeout-actions-right><a href=# class=swipeout-delete>Delete</a></div></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div><div class="list inset add-soother"><ul><li class="item-content item-input"><div class=item-inner><div class=item-input-wrap><input type=text placeholder="Add Soother" id=add-social> <span class=input-clear-button></span></div></div><div class=item-after><button class="col button button-fill button-round color-blue btn-add" @click="addSoother(\'social\')">+Add</button></div></li></ul><div class=block-footer>These lists will appear as activities to select in your daily journal entries.</div></div></div></div>';
      return r;
    }(this);
  },
  style: `
  .soother-intro p {
    margin: 0 0 12px;
    line-height: 1.5;
  }
  .list .block-footer {
    margin-bottom: 15px;
  }
  .add-soother {
    margin-top: 7px !important;
  }
  .add-soother .item-content {
    align-items: flex-end;
  }
  .add-soother .item-input-wrap {
    border: 1px solid #c9dbe2;
    border-radius: 12px;
    background: #ffffff;
    padding: 10px 14px;
    box-shadow: inset 0 1px 2px rgba(15, 48, 66, 0.08);
  }
  .add-soother input {
    font-size: 16px;
    color: #0f303f;
  }
  .add-soother input::placeholder {
    color: #6b8a99;
  }
  .add-soother .btn-add {
    border-radius: 999px;
    font-weight: 600;
    min-width: 90px;
  }
  .btn-add {
    margin-right: 8px;
  }
  .delete-account {
    color: #ff3b30;
    font-weight: 500;
  }
`,
  styleScoped: false
};
    